export default __webpack_public_path__ + "images/orange-70.png";